import moment from 'moment'
import { IOrderProps } from '@/entities/Order'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface IOrderState {
  response: IResponseProps<IOrderProps>
  current: IOrderProps | null
  year: number
  method: string | null
}

export const state = (): IOrderState => ({
  response: EmptyResponsePropsFactory(),
  current: null,
  year: moment().year(),
  method: null
})

export default state
